const KeenSlider = window.KeenSlider

const { setInitialised, addWheelControls } = window.BAO.Carousel.plugins

class ProductCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.3,
          spacing: 15,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2,
              spacing: 15,
            },
          },
          '(min-width: 901px)': {
            slides: {
              perView: 3,
              spacing: 30,
            },
          },
          '(min-width: 1201px)': {
            slides: {
              perView: 3,
              spacing: 50,
            },
          },
        },
        detailsChanged: (instance) => {
          const slideEls = this.querySelectorAll(
            '[data-product-carousel-el="slide"]',
          )
          slideEls.forEach((slideEl, index) => {
            const currentActiveSlide = instance.track.details.abs
            const matchingSlide = instance.track.details.slides[index]

            if (matchingSlide.abs <= currentActiveSlide) {
              slideEl.style.setProperty('--Slide_Transform', `rotate(${0}deg)`)
            } else {
              const slidePortion = matchingSlide.portion

              const rotateLimit = 2
              const rotateAmount = rotateLimit - rotateLimit * slidePortion

              slideEl.style.setProperty(
                '--Slide_Transform',
                `rotate(-${rotateAmount}deg)`,
              )
            }
          })
        },
      },
      [setInitialised(), addWheelControls('horizontal')],
    )
  }
}

if (!customElements.get('product-carousel')) {
  customElements.define('product-carousel', ProductCarousel)
}
